module.exports = __webpack_public_path__ + "img/userStory.08f9c503.jpg";